var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icon-park-solid:file-word"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2620_18405",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 2,
    width: 38,
    height: 46
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.4167 4.1665H31.25L41.6667 14.5832V43.7498C41.6667 44.3024 41.4472 44.8323 41.0565 45.223C40.6658 45.6137 40.1359 45.8332 39.5833 45.8332H10.4167C9.86414 45.8332 9.33424 45.6137 8.94354 45.223C8.55284 44.8323 8.33334 44.3024 8.33334 43.7498V6.24984C8.33334 5.6973 8.55284 5.1674 8.94354 4.7767C9.33424 4.386 9.86414 4.1665 10.4167 4.1665Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4.16667,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.675 20.833L19.8 35.4163L25.0084 24.9997L30.2167 35.4163L33.3417 20.833",
    stroke: "black",
    strokeWidth: 4.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2620_18405)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0 0H50V50H0V0Z",
    fill: "#0062FF"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocicon);
export default __webpack_public_path__ + "static/media/docicon.0c93fe63a2e10f37f5f95a60447298d4.svg";
export { ForwardRef as ReactComponent };